/**
 * commonService — shared helpers reused across counselling screens.
 */

/**
 * Designations that require a Subject selection. The subject list is keyed
 * differently per designation (see subjectListKey).
 */
export const SUBJECT_DESIGNATIONS = [
  '11',
  '103',
  '7',
  '36',
  '138',
  '139',
  '117',
];

/** Maps a designation to the Subject.json key that holds its subject list. */
export const subjectListKey = (designation: string): string => {
  switch (designation) {
    case '11':
      return 'BTStaffList';
    case '103':
      return 'BRTEStaffList';
    case '7':
      return 'PartTimeStaffList';
    case '36':
      return 'PGStaffList';
    case '138':
    case '139':
      return 'LecturerAndJunrLectrStfLst';
    default:
      return 'AllSubject';
  }
};

/** True when the given designation needs a Subject selection. */
export const requiresSubject = (designation: string | number): boolean =>
  SUBJECT_DESIGNATIONS.includes(String(designation));

/** Dropdown option shape. */
export interface Option {
  label: string;
  value: string;
}

/**
 * Resolves the subject list for a designation from the loaded Subject.json data.
 * Picks the right top-level key (see subjectListKey) and normalises each entry
 * into a { label, value } option. Returns [] if the key is missing/not an array.
 */
export const getSubjectListByDesignation = (
  subjectData: Record<string, unknown> | null | undefined,
  designation: string | number
): Option[] => {
  if (!subjectData) return [];
  const key = subjectListKey(String(designation));
  const list = subjectData[key];
  if (!Array.isArray(list)) return [];
  return list.map((x: any) => ({
    label: x.label,
    value: String(x.value),
  }));
};
